module.exports = __webpack_public_path__ + "media/images/common/support4-a3033c3042a1957c5a26312fefd75dfb.png";